module.exports = __webpack_public_path__ + "static/office-1-d00060e16d789762c412ca4bb830c294.jpg";